export const scrollToElement = (key: string) => {
  const el = document.getElementById(key)
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth'
    })
  }
}